module.exports = __webpack_public_path__ + "img/pic4.0297d7c2.png";